const HEADLESS = {
  SHOW_ALL: null,
  SHOW_MENU_ONLY: '1',
  HIDE_ALL: '2',
}

export { HEADLESS }